import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-show-promo',
    templateUrl: './show-promo.component.html',
    styleUrls: ['./show-promo.component.scss']
})
export class ShowPromoComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<ShowPromoComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    ngOnInit(): void {

    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.dialogRef.close(true);
    }

}
